import { THEME } from 'reactor/common';

const { COLOR } = THEME;

export default {
  autoCorrect: false,
  autoCapitalize: 'none',
  blurOnSubmit: true,
  // keyboardType: keyboard,
  // numberOfLines: lines,
  // multiline: lines > 1,
  // onChangeText: onChange,
  placeholderTextColor: COLOR.TEXT_LIGHTEN,
  underlineColorAndroid: 'transparent',
};
